import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

import { Neutrals, SemanticSuccess } from '../../../core-components/theme/color-palette/colors';
import { FOCUS_RING } from '../../../core-components/theme/focusRing';

export const REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';

export const STEP_BODY_GAP = 4;

export const stepBodySx: SystemStyleObject<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: STEP_BODY_GAP,
  minInlineSize: 0,
};

export const SETTINGS_SKELETON_ROWS = 3;

export const skeletonRowSx = (theme: Theme): SystemStyleObject<Theme> => ({
  blockSize: theme.controlHeight.medium,
  [REDUCED_MOTION]: { animation: 'none' },
});

export const skeletonCardSx: SystemStyleObject<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
};

export const quietLineSx: SystemStyleObject<Theme> = { color: Neutrals[600], display: 'block' };

export const liveLineSx: SystemStyleObject<Theme> = {
  ...quietLineSx,
  '&:empty': { position: 'absolute', inlineSize: 0, blockSize: 0, overflow: 'hidden' },
};

export const hearCardSx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', gap: 3 };

export const hearListSx: SystemStyleObject<Theme> = {
  margin: 0,
  paddingInlineStart: 5,
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  color: Neutrals[800],
};

export const actionColumnSx: SystemStyleObject<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: { xs: 'stretch', md: 'flex-start' },
  gap: 2,
};

export const blockActionSx: SystemStyleObject<Theme> = { inlineSize: { xs: '100%', md: 'auto' } };

export const numberValueSx: SystemStyleObject<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  color: Neutrals[900],
};

export const verifiedMarkSx: SystemStyleObject<Theme> = { color: SemanticSuccess[600], flexShrink: 0 };

export const okLineSx: SystemStyleObject<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  color: Neutrals[800],
  '&:focus-visible': { outline: FOCUS_RING },
};

export const linkRowSx: SystemStyleObject<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  columnGap: 1,
  marginInlineStart: -2,
};

export const welcomeSx: SystemStyleObject<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  minInlineSize: 0,
};

export const welcomeHeadingSx: SystemStyleObject<Theme> = { color: Neutrals[900] };
